"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageDetailsReducer = exports.initialState = void 0;
/* Package Imports */
var connected_react_router_1 = require("connected-react-router");
var moment_1 = __importDefault(require("moment"));
var typesafe_actions_1 = require("typesafe-actions");
/* Blast Imports */
var actions = __importStar(require("./actions"));
var models_1 = require("@app/_state/models");
var utils_1 = require("@app/_state/utils");
var newPackagesActions = __importStar(require("@app/features/new-packages/state/actions"));
var transfersAction = __importStar(require("@app/features/transfers/state/actions"));
var api_1 = require("@server/types/api");
exports.initialState = {
    isDownloading: false,
    isLoading: true
};
var packageDetailsReducer = function (state, action) {
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        // Packages actions
        case typesafe_actions_1.getType(actions.getPackageRequest):
            return __assign(__assign({}, state), { packageDetails: undefined, isDownloading: false, isLoading: true });
        case typesafe_actions_1.getType(actions.getPackageSuccess):
            return __assign(__assign({}, state), { packageDetails: utils_1.mapPackageToModel(action.payload), isDownloading: false, isLoading: false });
        case typesafe_actions_1.getType(actions.saveSearchTerm):
            return __assign(__assign({}, state), { savedSearchTerm: action.payload });
        // New Packages actions
        case typesafe_actions_1.getType(newPackagesActions.markPackageAsArchived): {
            if (state.packageDetails && state.packageDetails.id === action.payload) {
                return __assign(__assign({}, state), { packageDetails: __assign(__assign({}, state.packageDetails), { archived: true }) });
            }
            else {
                return state;
            }
        }
        // Transfers actions
        case typesafe_actions_1.getType(transfersAction.connectDownloadRequest): {
            if (!state.packageDetails || (state.packageDetails.id !== action.payload.packageId)) {
                return state;
            }
            if (!action.payload.filePath) {
                return __assign(__assign({}, state), { packageDetails: __assign(__assign({}, state.packageDetails), { state: models_1.PackageTransferState.IN_PROGRESS, transferredBytes: 0, errorMsg: '' }), isDownloading: true });
            }
            else {
                return __assign(__assign({}, state), { isDownloading: true });
            }
        }
        case typesafe_actions_1.getType(transfersAction.connectTransferReject):
            if (!state.packageDetails || (state.packageDetails.id !== action.payload.packageId)) {
                return state;
            }
            if (!action.payload.filePath) {
                return __assign(__assign({}, state), { packageDetails: __assign(__assign({}, state.packageDetails), { errorMsg: "Error downloading the package. Retry and 'Allow' connection with Aspera Connect", state: models_1.PackageTransferState.FAILED }), isDownloading: false });
            }
            else {
                return __assign(__assign({}, state), { isDownloading: false });
            }
        case typesafe_actions_1.getType(transfersAction.downloadReject): {
            if (!state.packageDetails || (state.packageDetails.id !== action.payload.packageId)) {
                return state;
            }
            if (!action.payload.filePath) {
                return __assign(__assign({}, state), { packageDetails: __assign(__assign({}, state.packageDetails), { errorMsg: "Error downloading the package", state: models_1.PackageTransferState.FAILED }), isDownloading: false });
            }
            else {
                return __assign(__assign({}, state), { isDownloading: false });
            }
        }
        case typesafe_actions_1.getType(transfersAction.updateTransfer): {
            if (!state.packageDetails || (state.packageDetails.id !== action.payload.packageId || (state.packageDetails.title !== action.payload.title && !moment_1.default(action.payload.creationDate).isSame(state.packageDetails.creationDate)))) {
                return state;
            }
            if (action.payload.isFullPackage) {
                return __assign(__assign({}, state), { packageDetails: __assign(__assign({}, state.packageDetails), { state: ((action.payload.direction === api_1.Direction.RECEIVE) && (action.payload.isFullPackage)) ? action.payload.state : undefined, transferredBytes: action.payload.transferredBytes, packageTransferId: (((action.payload.direction === api_1.Direction.RECEIVE) && (action.payload.isFullPackage)) && (action.payload.transferId)) ? action.payload.transferId : '', errorCode: action.payload.errorCode, errorDesc: action.payload.errorDesc, errorMsg: (action.payload.state === models_1.PackageTransferState.FAILED) ? 'Error downloading the package' : '' }), isDownloading: (action.payload.state !== models_1.PackageTransferState.IN_PROGRESS) ? false : true });
            }
            else {
                return __assign(__assign({}, state), { packageDetails: __assign({}, state.packageDetails), isDownloading: (action.payload.state !== models_1.PackageTransferState.IN_PROGRESS) ? false : true });
            }
        }
        // React Router actions
        case connected_react_router_1.LOCATION_CHANGE:
            return __assign(__assign({}, state), { isDownloading: false, packageDetails: undefined });
        default:
            return state;
    }
};
exports.packageDetailsReducer = packageDetailsReducer;
